export const NAV = [
  {
    sec: "Overview",
    items: [{ id: "dashboard", icon: "dashboard", label: "Dashboard", permission: "dashboard.view" }],
  },
  {
    sec: "Finance",
    items: [
      { id: "maintenance", icon: "maintenance", label: "Maintenance", permission: "maintenance.view" },
      { id: "petty-cash", icon: "cash", label: "Petty Cash", permission: "petty_cash.view" },
      { id: "bank", icon: "bank", label: "Bank Accounts", permission: "bank_accounts.view", feature: "FEATURE_BANK" },
      { id: "quotations", icon: "quotations", label: "Quotations & POs", permission: "quotations.view", feature: "FEATURE_FINANCE" },
      { id: "festival", icon: "festival", label: "Festival Accounts", permission: "festivals.view" },
    ],
  },
  {
    sec: "Operations",
    items: [
      { id: "vendors", icon: "vendors", label: "Vendors & AMC", permission: "vendors.view", feature: "FEATURE_VENDOR" },
      { id: "todos", icon: "todos", label: "To-Do Tasks", permission: "todos.view", feature: "FEATURE_TASK" },
      { id: "amenities", icon: "amenities", label: "Amenities", permission: "amenities.view", feature: "FEATURE_AMENITIES" },
      { id: "service-providers", icon: "users", label: "My Providers", permission: "", feature: "FEATURE_SERVICE_DIRECTORY" },
      { id: "gate-search", icon: "users", label: "Gate Security", permission: "gate.view", feature: "FEATURE_VISITOR" },
    ],
  },
  {
    sec: "Documents",
    items: [
      { id: "notices", icon: "notices", label: "Notices & Docs", permission: "notices.view" },
      { id: "documents", icon: "documents", label: "Document Mgmt", permission: "documents.view" },
      { id: "services", icon: "services", label: "Service Directory", permission: "services.view" },
    ],
  },
  {
    sec: "HR & Governance",
    items: [
      { id: "salary", icon: "salary", label: "Salary & Payroll", permission: "salary.view" },
      { id: "election", icon: "election", label: "Election Mgmt", permission: "election.view", feature: "FEATURE_ELECTION" },
      { id: "committee", icon: "users", label: "Committee", permission: "committee.view", feature: "FEATURE_COMMITTEE" },
    ],
  },
  {
    sec: "Administration",
    items: [
      { id: "users", icon: "users", label: "User Management", permission: "users.view" },
      { id: "billing", icon: "billing", label: "Billing & Plans", permission: "billing.view" },
      { id: "audit", icon: "audit", label: "Audit Log", permission: "audit.view", feature: "FEATURE_AUDIT" },
      { id: "admin-providers", icon: "users", label: "All Providers", permission: "service_providers.view" },
    ],
  },
];
